var amdi18n={"__root":{"message_text":"Do you want to delete and possibly revoke your Cloud Identity irretrievably?","revoke_cloud_identity":"Revoke Cloud Identity","delete_revoke":"Yes, please delete and revoke","delete":"Yes, please delete"},"__de":{"message_text":"Möchten Sie Ihre Cloud Identität unwiederbringlich löschen und gegebenenfalls sperren?","revoke_cloud_identity":"Cloud Identität sperren","delete_revoke":"Ja, bitte löschen und sperren","delete":"Ja, bitte löschen"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/identity/nls/IdentityDeleteView_strings.js
// module id = 341
// module chunks = 1